// ---------------------------------------------------------------
// MOCK DATA for MBS Cayman (frontend-only phase)
// All of this will be replaced by real backend API calls later.
// ---------------------------------------------------------------

export const SITE = {
  name: "Modern Business Solutions",
  shortName: "MBS Cayman",
  tagline: "TOEIC\u00AE Testing Center for the Cayman Islands",
  address: "93 Hospital Rd, SIGMA Building, 1st Flr, George Town",
  addressNote: "Right Before the HSA Hospital",
  phone: "1-345-924-6887",
  email: "info@mbscayman.com",
  hours: "Mon-Fri: 9:00 AM - 3:00 PM",
  sisterIslandsEmail: "ELT.BRAC@GMAIL.COM",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/8191964/pexels-photo-8191964.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  examRoom: "/hero-mbs.jpg",
  examWriting: "https://images.unsplash.com/photo-1571666522201-5b39e6d0cd29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxzbWlsaW5nJTIwaGVhZHNldCUyMGNvbXB1dGVyfGVufDB8fHx8MTc4NzQ2Nzc3OHww&ixlib=rb-4.1.0&q=85&w=1200",
  consultation: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxzbWlsaW5nJTIwaGVhZHNldCUyMGNvbXB1dGVyfGVufDB8fHx8MTc4NzQ2Nzc3OHww&ixlib=rb-4.1.0&q=85&w=1200",
  testingMan: "https://images.unsplash.com/photo-1637855190680-5cbe1d870b46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxzbWlsaW5nJTIwaGVhZHNldCUyMGNvbXB1dGVyfGVufDB8fHx8MTc4NzQ2Nzc3OHww&ixlib=rb-4.1.0&q=85&w=1200",
  devTeam: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=900&q=80",
  appDev: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=900&q=80",
  accounting: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=900&q=80",
  cayman: "https://images.unsplash.com/photo-1627512729059-fb322f8436f7?w=1200&q=80",
  workers: "https://images.pexels.com/photos/8101459/pexels-photo-8101459.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TIME_SLOTS = ["10:00 AM", "11:30 AM"];
export const SLOT_CAPACITY = 10;

export const TESTS = [
  {
    id: "bridge-lr",
    name: "Redesigned TOEIC\u00AE Bridge Institutional Listening & Reading Test",
    shortName: "Redesigned TOEIC Bridge Listening & Reading",
    badge: "Most Popular \u2022 Work Permits",
    price: 135,
    priceNote: "CI $135.00 per test",
    duration: "Approx. 1 hour",
    questions: "100 Questions (50 Listening \u2022 50 Reading)",
    results: "Results available in 2 business days",
    scoreScale: "Each section scored 15\u201350 \u2022 Total 30\u2013100 \u2022 CEFR A1\u2013B1",
    description:
      "Our most popular test, required for Work Permit applications in the Cayman Islands. Measures everyday English listening and reading skills for beginner to intermediate levels.",
    schedule: "Monday \u2013 Friday at 10:00 AM and 11:30 AM",
  },
  {
    id: "toeic-lr",
    name: "TOEIC\u00AE Listening & Reading Test",
    shortName: "TOEIC Listening & Reading",
    badge: "Professional Certification",
    price: 275,
    priceNote: "CI $275.00 per test",
    duration: "Approx. 2 hours",
    questions: "200 Questions (100 Listening \u2022 100 Reading)",
    results: "Results available in 2 business days",
    scoreScale: "Each section scored 5\u2013495 \u2022 Total 10\u2013990 \u2022 CEFR A1\u2013C1",
    description:
      "The global standard for assessing intermediate to advanced English listening and reading proficiency in the workplace.",
    schedule: "Tuesdays and Thursdays at 12:30 PM",
  },
  {
    id: "toeic-sw",
    name: "TOEIC\u00AE Speaking & Writing Test",
    shortName: "TOEIC Speaking & Writing",
    badge: "Productive Skills",
    price: 220, // PLACEHOLDER PRICE - confirm with MBS
    priceNote: "CI $220.00 per test",
    duration: "Approx. 80 minutes",
    questions: "19 Questions (11 Speaking \u2022 8 Writing)",
    results: "Results available in 7 business days",
    scoreScale: "Each section scored 0\u2013200 \u2022 CEFR A1\u2013C1",
    description:
      "Measures English speaking and writing skills for effective communication in real workplace situations.",
    schedule: "Fridays at 1:00 PM",
  },
  {
    id: "toeic-lr-public",
    name: "TOEIC\u00AE Listening & Reading PUBLIC Test",
    shortName: "TOEIC Listening & Reading PUBLIC",
    badge: "Overseas Scores \u2022 Official Public Session",
    price: 325,
    priceNote: "CI $325.00 per test",
    duration: "Total duration 2 hours",
    questions: "200 Questions (100 Listening \u2022 100 Reading)",
    results: "Results available in 2 business days",
    scoreScale: "Each section scored 5\u2013495 \u2022 Total 10\u2013990 \u2022 CEFR A1\u2013C1",
    description:
      "The official PUBLIC TOEIC Listening & Reading test session, used for presenting scores overseas. Requires a passport-style head shot photo and email address at registration.",
    schedule: "The 2nd Tuesday of every month at 12:30 PM",
  },
];

export const ADDITIONAL_TESTS = [
  {
    id: "toeic-speaking",
    name: "TOEIC\u00AE Speaking Test",
    shortName: "TOEIC Speaking",
    badge: "Individual Skill Test",
    price: 110,
    priceNote: "CI $110.00 per test",
    questions: "8 Questions",
    duration: "60 Minutes Long",
    level: "Advanced English Assessment",
    availability: "Fridays at 12:30 PM \u2022 2 seats per session",
    mode: "Computer Administered",
    schedule: "Fridays at 12:30 PM",
    results: "Results available in 7 business days",
    scoreScale: "Scored 0\u2013200 \u2022 CEFR A1\u2013C1",
    description:
      "Measures spoken English proficiency for the workplace. 8 questions, approximately 60 minutes.",
  },
  {
    id: "toeic-writing",
    name: "TOEIC\u00AE Writing Test",
    shortName: "TOEIC Writing",
    badge: "Individual Skill Test",
    price: 110,
    priceNote: "CI $110.00 per test",
    questions: "11 Questions",
    duration: "20 Minutes Long",
    level: "Advanced English Assessment",
    availability: "Fridays at 12:30 PM \u2022 2 seats per session",
    mode: "Computer Administered",
    schedule: "Fridays at 12:30 PM",
    results: "Results available in 7 business days",
    scoreScale: "Scored 0\u2013200 \u2022 CEFR A1\u2013C1",
    description:
      "Measures written English proficiency for the workplace. 11 questions, approximately 20 minutes.",
  },
];

// Temporary kill-switch for all customer-facing online payment UI.
// Set to true (and PAYMENTS_ENABLED="true" in backend/.env) to unhide.
export const ONLINE_PAYMENTS_ENABLED = true;

export const OTHER_SERVICES = [
  {
    id: "certified-copy",
    name: "Certified Copy of Test Results",
    price: 35,
    priceNote: "CI $35.00 per copy",
    description:
      "Need an additional official copy of your TOEIC® score report? We provide certified copies of test results for work permit renewals, overseas applications and personal records.",
    availability: "Available at our office — call, email or visit us to request a copy.",
  },
];

export const REGISTRATION_INTRO =
  "Please fill out the information below to schedule your test. Payment must be made on or before check in and test takers are required to arrive no later than 20 minutes before the test start time. Late arrivals will not be allowed to take the test. Select the date you desire from the available options below and then fill out the form information. You will receive a confirmation page after clicking the submit button. Results will be available in two business days (seven business days for the Speaking & Writing test). Accepted forms of payment are cash, debit/credit card and cheques. Each testee must provide 2 forms of identification (one being their passport) when checking in to take the test. Online booking closes at 7:00 PM the day before the test date (2 days before for the PUBLIC test).";

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina",
  "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
  "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina",
  "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
  "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia",
  "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia", "Cuba", "Cyprus",
  "Czechia (Czech Republic)", "Democratic Republic of the Congo", "Denmark", "Djibouti",
  "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea",
  "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia",
  "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
  "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
  "Ireland", "Israel", "Italy", "Ivory Coast (C\u00f4te d'Ivoire)", "Jamaica", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon",
  "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar",
  "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
  "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
  "Mozambique", "Myanmar (Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
  "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan",
  "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland",
  "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
  "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia",
  "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain",
  "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
  "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu",
  "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe",
];

export const FAQS = [
  {
    q: "How much does the Redesigned TOEIC Bridge test cost?",
    a: "The cost per test is CI $135.00. Payment must be made on or before check in. Accepted forms of payment are cash, debit/credit card and cheques.",
  },
  {
    q: "How do I schedule a test?",
    a: "You can schedule your test using the online booking system on this website, or by calling us at 1-345-924-6887. The Redesigned TOEIC Bridge test is offered Monday - Friday at 10:00 AM and 11:30 AM. The TOEIC Listening & Reading test runs Tuesdays and Thursdays at 12:30 PM, the Speaking & Writing test runs Fridays at 1:00 PM, the individual Speaking and Writing tests run Fridays at 12:30 PM (2 seats each), and the Listening & Reading PUBLIC test runs on the 2nd Tuesday of every month at 12:30 PM.",
  },
  {
    q: "What is the deadline to book a test?",
    a: "Online booking closes at 7:00 PM the day before the test date. For the PUBLIC Listening & Reading test, booking closes 2 days before the test date, and there are no refunds for cancellations 5 days or less before the test.",
  },
  {
    q: "What do I need to bring on test day?",
    a: "Each testee must provide 2 forms of government identification (one being their passport) when checking in to take the test. If the test is being taken for a work permit application, a copy of your work permit must also be presented at check in.",
  },
  {
    q: "What time should I arrive?",
    a: "Test takers are required to arrive no later than 20 minutes before the test start time. Late arrivals will not be allowed to take the test.",
  },
  {
    q: "When will I receive my results?",
    a: "Results for the Redesigned TOEIC Bridge and TOEIC Listening & Reading tests will be available in two business days. Results for the TOEIC Speaking & Writing test will be available in seven business days.",
  },
  {
    q: "What score do I need for a Cayman Islands work permit?",
    a: "The Workforce Opportunities and Residency Cayman (WORC) department requires a minimum score of Level A2 in the Listening category and Level A1 in the Reading category on the Redesigned TOEIC Bridge test. The minimum score needed for the Redesigned TOEIC Bridge Listening and Reading test is 26 in the Listening section and 19 in the Reading section.",
  },
  {
    q: "How long are my scores valid?",
    a: "TOEIC scores are considered valid for two years from the date of the test.",
  },
  {
    q: "I live in Cayman Brac or Little Cayman. Can I take the test there?",
    a: "Yes. To schedule a test in the Sister Islands please email ELT.BRAC@GMAIL.COM.",
  },
  {
    q: "Can I retake the test if I don't get the score I need?",
    a: "Yes, you may register and retake the test. When registering, simply indicate that you have taken the test before on the registration form.",
  },
];

export const CEFR_LEVELS = [
  { level: "A1", label: "Beginner", desc: "Can understand and use familiar everyday expressions and very basic phrases." },
  { level: "A2", label: "Elementary", desc: "Can understand sentences and frequently used expressions related to areas of most immediate relevance." },
  { level: "B1", label: "Intermediate", desc: "Can deal with most situations likely to arise while working or travelling. Can produce simple connected text." },
  { level: "B2", label: "Upper Intermediate", desc: "Can interact with a degree of fluency and spontaneity that makes regular interaction quite possible." },
  { level: "C1", label: "Advanced", desc: "Can express ideas fluently and spontaneously and use language flexibly and effectively for professional purposes." },
];

// ---------------------------------------------------------------
// LocalStorage-backed mock booking store
// ---------------------------------------------------------------
const STORE_KEY = "mbs_mock_bookings";

export const getBookings = () => {
  try {
    return JSON.parse(localStorage.getItem(STORE_KEY)) || [];
  } catch {
    return [];
  }
};

export const saveBooking = (booking) => {
  const bookings = getBookings();
  const ref =
    "MBS-" +
    Math.random().toString(36).substring(2, 6).toUpperCase() +
    Date.now().toString().slice(-4);
  const record = {
    ...booking,
    id: ref,
    confirmationNumber: ref,
    status: "confirmed",
    createdAt: new Date().toISOString(),
  };
  bookings.push(record);
  localStorage.setItem(STORE_KEY, JSON.stringify(bookings));
  return record;
};

export const cancelBooking = (id) => {
  const bookings = getBookings().map((b) =>
    b.id === id ? { ...b, status: "cancelled" } : b
  );
  localStorage.setItem(STORE_KEY, JSON.stringify(bookings));
};

export const seatsRemaining = (testId, dateISO, slot) => {
  const booked = getBookings()
    .filter(
      (b) =>
        b.testId === testId &&
        b.date === dateISO &&
        b.timeSlot === slot &&
        b.status !== "cancelled"
    )
    .reduce((sum, b) => sum + (Number(b.quantity) || 1), 0);
  return Math.max(0, SLOT_CAPACITY - booked);
};
